<sh-fixed-header-panel>
  <ng-container title>{{'facets.title' | translate}}</ng-container>
  <ng-container head
    >@if ((selectedFacets$ | async)?.length) {
    <sh-facet-summary
      [selectedFacets]="selectedFacets$ | async"
      [chosenFiltersMsg]="'facets.summary.chosen' | translate"
      [clearMsg]="'facets.summary.clear' | translate"
      (clear)="onClear()"
      (removeFacetValue)="onRemoveFacet($event)"
    ></sh-facet-summary>
  }
</ng-container>
<ng-container body>
  <ng-container *ngTemplateOutlet="(facetsLoading$ | async) === false ? facetList : loading "> </ng-container>
</ng-container>
</sh-fixed-header-panel>

<ng-template #facetList>
  @if (shFacets$ | async; as facets) {
    @if (facets.length) {
      <sh-facet-list
        [facets]="facets"
        [showMoreMsg]="'facets.search-more' | translate"
        [blockShowMore]="blockShowMore"
        (facetSelected)="onFacetSelected($event)"
        (loadMore)="onLoadMore($event)"
      ></sh-facet-list>
    } @else {
      {{'facets.no-results' | translate}}
    }
  }
</ng-template>


<ng-template #loading>{{'ui.loading' | translate}}</ng-template>
